module.exports = __webpack_public_path__ + "img/route-button.03a9c7df.svg";